import agentBankDetailsDictionary from '@entities/agent-bank-details/i18n/ru/agent-bank-details.dic.json';

export const agentBankDetails = {
  AGENT_BANK_DETAILS: agentBankDetailsDictionary,
};

export const agentBankDetailsNamespaces = ['AGENT_BANK_DETAILS'];
